import AppRouter from "./Router";
import "./App.scss";

export default function App() {
  return <AppRouter />;
}
